import { UserListPage, UserEditPage, UserCreatePage } from './imports';

export const userRoutes = [
  {
    path: 'users',
    children: [
      {
        element: <UserListPage />,
        index: true,
      },
      {
        path: 'list',
        element: <UserListPage />,
      },
      {
        path: ':id/edit',
        element: <UserEditPage />,
      },
      {
        path: 'new',
        element: <UserCreatePage />,
      },
    ],
  },
];
